import React from "react";

const IntroPage = props => {
    return (
        <div className="introduce mt-4 mb-5">
            <div className="container">
                <h3 className="text-center">Giới thiệu Ban Quản lý Khu kinh tế</h3>
                <h5>Chức năng, nhiệm vụ</h5>
                <p>
                    Ban Quản lý Khu kinh tế ... được thành lập theo Quyết định số
                    .../QĐ-TTg ngày .../.../... của Thủ tướng Chính phủ, là cơ quan trực thuộc
                    UBND thành phố ..., thực hiện chức năng quản lý nhà nước trực tiếp
                    đối với Khu kinh tế ... và các khu công nghiệp trên địa bàn
                    thành phố; quản lý và tổ chức thực hiện chức năng cung ứng dịch vụ hành
                    chính công và dịch vụ hỗ trợ khác liên quan đến hoạt động đầu tư và sản
                    xuất kinh doanh cho nhà đầu tư trong khu kinh tế và các khu công nghiệp
                    trên địa bàn thành phố theo quy định của pháp luật.
                </p>

                <p>
                    Ban Quản lý Khu kinh tế ... có trụ sở riêng và Văn phòng Đại diện Ban
                    Quản lý đặt tại các khu công nghiệp, khu kinh tế trên địa bàn thành phố,
                    các đơn vị sự nghiệp trực thuộc gồm: Trường Trung cấp Khu kinh tế, Trung
                    tâm Giới thiệu việc làm và Tư vấn dịch vụ đầu tư, Ban Quản lý Dự án hạ
                    tầng Khu kinh tế ....
                </p>

                <p>
                    Quyết định số .../QĐ-UBND ngày .../.../... của Ủy ban nhân dân thành
                    phố ... đã quy định rõ các nhiệm vụ, quyền hạn của Ban Quản lý Khu
                    kinh tế ... như sau:
                </p>

                <h5>Nhiệm vụ và quyền hạn của Ban Quản lý đối với các khu công nghiệp, khu chế xuất</h5>
                <p>(sau đây gọi chung là khu công nghiệp)</p>

                <ol>
                    <li>
                        <strong>Trình Ủy ban nhân dân thành phố:</strong>
                        <ol type="a">
                            <li>Dự thảo văn bản quy định chức năng, nhiệm vụ, quyền hạn và cơ cấu tổ chức của Ban Quản lý;</li>
                            <li>Dự thảo văn bản quy định điều kiện, tiêu chuẩn chức danh đối với Trưởng, Phó các Phòng chuyên môn và Giám đốc, Phó Giám đốc các đơn vị trực thuộc Ban Quản lý;</li>
                            <li>Dự thảo Đề án thành lập, tổ chức lại các đơn vị sự nghiệp theo quy định của pháp luật;</li>
                            <li>Quy chế phối hợp làm việc với các cơ quan chuyên môn thuộc Ủy ban nhân dân thành phố và các cơ quan, đơn vị khác có liên quan để thực hiện các nhiệm vụ và quyền hạn được giao theo cơ chế một cửa, một cửa liên thông;</li>
                            <li>Dự thảo Đề án quy hoạch, điều chỉnh bổ sung quy hoạch phát triển các khu công nghiệp, khu kinh tế;</li>
                            <li>Kế hoạch hàng năm và 5 năm về phát triển khu công nghiệp, khu kinh tế, phát triển nguồn nhân lực và vốn đầu tư phát triển;</li>
                            <li>Dự thảo quyết định, chỉ thị, văn bản; chương trình, biện pháp tổ chức thực hiện nhiệm vụ cải cách hành chính nhà nước về lĩnh vực khu công nghiệp, khu kinh tế thuộc phạm vi quản lý của Ban Quản lý theo quy định pháp luật.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Trình Chủ tịch Ủy ban nhân dân thành phố:</strong>
                        <ol type="a">
                            <li>Dự thảo quyết định thành lập, sáp nhập, chia tách, tổ chức lại, giải thể các tổ chức, đơn vị thuộc Ban Quản lý theo quy định của pháp luật;</li>
                            <li>Dự thảo các văn bản thuộc thẩm quyền ban hành của Chủ tịch Ủy ban nhân dân thành phố về lĩnh vực khu công nghiệp, khu kinh tế.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Giúp Ủy ban nhân dân thành phố quản lý việc sử dụng vốn ngân sách nhà nước</strong>
                        <p>đầu tư xây dựng, phát triển khu công nghiệp, khu kinh tế;</p>
                    </li>

                    <li>
                        <strong>Hướng dẫn, tổ chức thực hiện và kiểm tra</strong>
                        <p>việc thực hiện các văn bản pháp luật, quy hoạch, kế hoạch, đề án, dự án, cơ chế, chính sách về khu công nghiệp, khu kinh tế sau khi được ban hành, phê duyệt; thông tin, tuyên truyền, hướng dẫn, phổ biến, theo dõi thi hành pháp luật về khu công nghiệp, khu kinh tế trên địa bàn thành phố ....</p>
                    </li>

                    <li>
                        <strong>Về quản lý đầu tư:</strong>
                        <ol type="a">
                            <li>Tiếp nhận, cấp, điều chỉnh, thu hồi Giấy chứng nhận đăng ký đầu tư đối với các dự án đầu tư thuộc thẩm quyền theo quy định của pháp luật về đầu tư;</li>
                            <li>Tổ chức hoạt động xúc tiến đầu tư theo kế hoạch đã được phê duyệt; tham gia chương trình xúc tiến đầu tư; hướng dẫn, hỗ trợ nhà đầu tư trong quá trình chuẩn bị và triển khai dự án; báo cáo định kỳ hoạt động xúc tiến đầu tư;</li>
                            <li>Giải quyết khó khăn, vướng mắc của nhà đầu tư; đánh giá hiệu quả đầu tư; gửi báo cáo hoạt động đầu tư, sản xuất kinh doanh tới Ủy ban nhân dân thành phố và Bộ Kế hoạch và Đầu tư theo quy định.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Về quản lý môi trường:</strong>
                        <ol type="a">
                            <li>Tổ chức thẩm định và phê duyệt báo cáo đánh giá tác động môi trường đối với các dự án trong khu công nghiệp theo ủy quyền;</li>
                            <li>Tiếp nhận đăng ký và xác nhận kế hoạch bảo vệ môi trường cho các đối tượng thuộc diện phải đăng ký;</li>
                            <li>Thẩm định, phê duyệt đề án bảo vệ môi trường chi tiết và đơn giản theo ủy quyền;</li>
                            <li>Kiểm tra, xác nhận hoàn thành công trình bảo vệ môi trường phục vụ giai đoạn vận hành dự án.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Về quản lý quy hoạch và xây dựng:</strong>
                        <ol type="a">
                            <li>Điều chỉnh quy hoạch chi tiết xây dựng đã được phê duyệt nhưng không làm thay đổi chức năng sử dụng đất;</li>
                            <li>Thẩm định thiết kế cơ sở đối với dự án đầu tư nhóm B, C thuộc diện phải thẩm định;</li>
                            <li>Cấp, điều chỉnh, gia hạn, cấp lại, thu hồi Giấy phép xây dựng đối với công trình trong khu công nghiệp theo phân cấp/ủy quyền;</li>
                            <li>Quản lý quy hoạch, xây dựng công trình, chất lượng công trình theo pháp luật về xây dựng và phân cấp/ủy quyền.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Quản lý nhà nước về lao động (theo hướng dẫn của Bộ LĐ-TB&XH):</strong>
                        <ol type="a">
                            <li>Tiếp nhận báo cáo giải trình của doanh nghiệp về nhu cầu sử dụng lao động nước ngoài; tổng hợp và trình Chủ tịch UBND thành phố quyết định theo ủy quyền;</li>
                            <li>Cấp, cấp lại, thu hồi Giấy phép lao động cho lao động nước ngoài; xác nhận một số trường hợp không thuộc diện cấp giấy phép;</li>
                            <li>Đăng ký nội quy lao động, tiếp nhận thỏa ước lao động tập thể theo ủy quyền;</li>
                            <li>Tiếp nhận thông báo về việc cho thôi việc nhiều người lao động, báo cáo cho thuê lại lao động, kết quả đào tạo hàng năm;</li>
                            <li>Tiếp nhận hồ sơ hợp đồng nhận lao động thực tập, hoạt động đưa người lao động đi làm việc ở nước ngoài theo ủy quyền;</li>
                            <li>Tiếp nhận khai trình việc sử dụng lao động, báo cáo thay đổi về lao động; nhận thông báo về việc tổ chức làm thêm;</li>
                            <li>Nhận thông báo về địa điểm, thời gian hoạt động và người quản lý của doanh nghiệp cho thuê lại lao động;</li>
                            <li>Thực hiện quản lý lao động gồm an toàn lao động, vệ sinh, xây dựng quan hệ lao động, giải quyết tranh chấp, đình công theo pháp luật.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Về quản lý thương mại:</strong>
                        <ol type="a">
                            <li>Cấp, sửa đổi, gia hạn Giấy phép thành lập Văn phòng đại diện thương mại của tổ chức, thương nhân nước ngoài;</li>
                            <li>Cấp Giấy phép kinh doanh, bổ sung mục tiêu kinh doanh cho doanh nghiệp có vốn đầu tư nước ngoài;</li>
                            <li>Cấp các loại Giấy chứng nhận đủ điều kiện kinh doanh, Giấy phép kinh doanh một số mặt hàng thuộc phạm vi quản lý;</li>
                            <li>Cấp Giấy chứng nhận xuất xứ hàng hóa sản xuất trong KCN theo hướng dẫn/ủy quyền của Bộ Công thương.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Về quản lý đất đai, bất động sản:</strong>
                        <ol type="a">
                            <li>Tiếp nhận đăng ký khung giá cho thuê đất, cho thuê lại đất và phí hạ tầng của nhà đầu tư xây dựng kinh doanh kết cấu hạ tầng;</li>
                            <li>Thực hiện chức năng, nhiệm vụ về đất đai theo Điều 151 Luật Đất đai và các Nghị định hướng dẫn liên quan.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Cấp một số loại giấy phép, chứng chỉ</strong>
                        <p>Theo thẩm quyền, hướng dẫn và ủy quyền của các Bộ, UBND thành phố và cơ quan có thẩm quyền.</p>
                    </li>

                    <li>
                        <strong>Các nhiệm vụ và quyền hạn khác:</strong>
                        <ol type="a">
                            <li>Thực hiện hợp tác quốc tế về phát triển khu công nghiệp, khu kinh tế theo quy định;</li>
                            <li>Tổ chức nghiên cứu, ứng dụng tiến bộ khoa học kỹ thuật; xây dựng hệ thống thông tin phục vụ quản lý;</li>
                            <li>Kiểm tra, xử lý hành vi vi phạm pháp luật trong các lĩnh vực thuộc phạm vi quản lý; tham gia thanh tra, giải quyết khiếu nại, tố cáo;</li>
                            <li>Quản lý tổ chức bộ máy, biên chế, chính sách lao động, tiền lương, đào tạo, khen thưởng, kỷ luật theo quy định;</li>
                            <li>Quản lý và chịu trách nhiệm về tài chính, tài sản được giao;</li>
                            <li>Thực hiện công tác báo cáo định kỳ và đột xuất về tình hình thực hiện nhiệm vụ; quản lý số liệu, báo cáo tài chính doanh nghiệp;</li>
                            <li>Tổ chức phong trào thi đua và khen thưởng cho doanh nghiệp trong khu công nghiệp;</li>
                            <li>Thực hiện nhiệm vụ, quyền hạn khác theo phân công, ủy quyền của UBND thành phố.</li>
                        </ol>
                    </li>
                </ol>
                <section />
            </div>
        </div >
    )
}

export default IntroPage;